function toggleCustomSelect() {
    document.querySelector('.custom-select-wrapper .custom-select-dropdown')?.classList.toggle('open');
}
document.addEventListener('DOMContentLoaded', function () {
    if (!window.matchMedia("(max-width: 900px)").matches) return;

    const dropdown = document.querySelector('.custom-select-wrapper .custom-select-dropdown');
    const servicesMap = window.servicesMap || {};

    document.addEventListener('click', function (e) {
        if (!dropdown.contains(e.target)) {
            dropdown.classList.remove('open');
        }

        if (e.target.classList.contains('custom-option')) {
            const title = e.target.getAttribute('data-title');
            document.getElementById('custom-select-text').innerText = e.target.innerText;
            document.getElementById('custom-service-description').innerHTML = servicesMap[title] || '';
            dropdown.classList.remove('open');

            document.querySelectorAll('.custom-option').forEach(opt => opt.classList.remove('selected'));
            e.target.classList.add('selected');
        }
    });
});
